import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'
import MeliInputVehicle from '../interfaces/MeliInputVehicle.ts'
import MeliPublishResult from '../interfaces/MeliPublishResult.ts'

import {
  makeUrlMeliDelete,
  makeUrlMeliPublish,
  makeUrlMeliSetPublished,
  makeUrlMeliUpdateData,
  makeUrlMeliUpdateDescription,
} from './connectionData.tsx'

const useMeliPublisher = () => {
  const [errorMeliPublish, setErrorMeliPublish] = useState<Error | null>(null)
  const [errorMeliSetPublished, setErrorMeliSetPublished] = useState<Error | null>(null)
  const [errorMeliDelete, setErrorMeliDelete] = useState<Error | null>(null)
  const [errorMeliUpdateData, setErrorMeliUpdateData] = useState<Error | null>(null)
  const [errorMeliUpdateDescription, setErrorMeliUpdateDescription] = useState<Error | null>(null)

  const [loading, setLoading] = useState<boolean>(false)

  const meliPublish = async (vehicle: MeliInputVehicle, profile: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlMeliPublish()

      const res = await customPost<MeliPublishResult>(apiUrl, { vehicle, profile })

      setErrorMeliPublish(null)

      return res
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorMeliPublish(err)
      } else {
        setErrorMeliPublish(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }
  // Marca el vehiculo como yapo_publishedAt
  const meliSetPublished = async (_id: string, by: string, identifier: string, permalink?: string, title?: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlMeliSetPublished()
      await customPost(apiUrl, { _id, by, identifier, permalink, title })

      setErrorMeliSetPublished(null)

      return 'OK'
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorMeliSetPublished(err)
      } else {
        setErrorMeliSetPublished(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }
  // Borra el aviso en mercado libre
  const meliDelete = async (_id: string, profile: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlMeliDelete()
      await customPost(apiUrl, { _id: _id, profile: profile })

      setErrorMeliDelete(null)

      return 'OK'
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorMeliDelete(err)
      } else {
        setErrorMeliDelete(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Update vehicle data only (excluding description)
  const meliUpdateData = async (vehicle: MeliInputVehicle, profile: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlMeliUpdateData()

      const res = await customPost<MeliPublishResult>(apiUrl, { vehicle, profile })

      setErrorMeliUpdateData(null)

      return res
    } catch (err) {
      if (err instanceof Error) {
        setErrorMeliUpdateData(err)
      } else {
        setErrorMeliUpdateData(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Update vehicle description only
  const meliUpdateDescription = async (
    vehicleId: string,
    identifier: string,
    description: string,
    profile: string,
    currentDescription?: string
  ) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlMeliUpdateDescription()

      const res = await customPost(apiUrl, {
        vehicleId,
        identifier,
        description,
        profile,
        currentDescription,
      })

      setErrorMeliUpdateDescription(null)

      return res
    } catch (err) {
      if (err instanceof Error) {
        setErrorMeliUpdateDescription(err)
      } else {
        setErrorMeliUpdateDescription(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return {
    loading,
    meliPublish,
    errorMeliPublish,
    meliSetPublished,
    errorMeliSetPublished,
    meliDelete,
    errorMeliDelete,
    meliUpdateData,
    errorMeliUpdateData,
    meliUpdateDescription,
    errorMeliUpdateDescription,
  }
}

export default useMeliPublisher
